<script setup lang="ts">
import { useTutorBillingInfoPage } from '../model/tutor-billing-info.hook'
import TableTutorBilling from './TableTutorBilling.vue'
import ModalTutorBillingView from './modals/ModalTutorBillingView.vue'
import ModalTutorBillingErase from './modals/ModalTutorBillingErase.vue'
import ModalTutorBillingNewAccount from './modals/ModalTutorBillingNewAccount.vue'
import ModalTutorBillingChangeRequest from './modals/ModalTutorBillingChangeRequest.vue'
import ModalTutorBillingBulkFlags from './modals/ModalTutorBillingBulkFlags.vue'
import ModalTutorBillingBulkConfirm from './modals/ModalTutorBillingBulkConfirm.vue'
import ModalTutorBillingBulkErase from './modals/ModalTutorBillingBulkErase.vue'
import ModalTutorBillingExport from './modals/ModalTutorBillingExport.vue'

defineOptions({
  name: 'TutorBillingInfoPage',
})

const { canView } = useTutorBillingInfoPage()
</script>

<template>
  <template v-if="canView">
    <TableTutorBilling />
    <ModalTutorBillingView />
    <ModalTutorBillingErase />
    <ModalTutorBillingNewAccount />
    <ModalTutorBillingChangeRequest />
    <ModalTutorBillingBulkFlags />
    <ModalTutorBillingBulkConfirm />
    <ModalTutorBillingBulkErase />
    <ModalTutorBillingExport />
  </template>
  <div
    v-else
    class="tutor-billing-info__denied"
  >
    You don't have access to this page
  </div>
</template>

<style scoped lang="scss" src="./TutorBillingInfoPage.scss" />
